import { ReactNode } from "react";
import { Stack } from "@mui/material";

export const RowWrapper = ({
  children,
  isHighlighted,
  is_activated,
}: {
  children: ReactNode;
  isHighlighted?: boolean;
  is_activated?: boolean;
}) => {
  return (
    <Stack
      sx={{
        backgroundColor: isHighlighted ? "rgb(244, 245, 249)" : "transparent",
        borderBottom: "1px solid #E0E0E0",
        padding: "14px 0",
        flexWrap: "nowrap",
        flexDirection: "row",
        ...(is_activated && {
          backgroundColor: "#F3FAF5",
          border: "1px solid #27AE60",
        }),
      }}
    >
      {children}
    </Stack>
  );
};
